export function translate(key) {
  key = key.trim()
  switch (key) {
    case "addOrder":return "ثبت سفارش";
    case "getOrders":return "سفارش ها";
    case "reminder":return "یادآوری";
    case "getProducts":return "محصول ها";
    case "finance":return "مالی";
    case "getCustomers":return "مشتریان";
    case "getEmployees":return "کارمندان";
    case "getDiscounts":return "تخفیف ها";
    case "saleOpprotunity":return "فرصت فروش";
    case "family":return "نام";
    case "company":return "نام شرکت";
    case "address":return "آدرس";
    case "price":return "قیمت";
    case "quantity":return "تعداد";
    case "excelProduct":return "اکسل محصول ها";
    case "excelCustomer":return "اکسل مشتریان";
    case "financialCode":return "کد اقتصادی و فکس";
    case "nationalIDCode":return "کدملی";
    case "getAllSaleOpprotunity":return "مدیریت و مشاهده همه فرصت فروش ها";
    case "leads":return "سرنخ";
    case "addReceipt":return "ثبت فاکتور";
    case "getReceipts":return "فاکتور ها";
    case "getSuppliers":return "تامین کننده ها";
    case "getStock":return "مواد خام";
    case "ExcelProducts":return "اکسل محصول ها";
    case "currentCosts":return "هزینه های جاری";
    case "getExcelCustomers":return "اکسل مشتریان";
    case "employeeRequests":return "درخواست های کارمندان";
    case "uploadExcelLeads":return "بارگذاری اکسل سرنخ";
    case "getExcelSuppliers":return "اکسل تامین کننده ها";
    case "financialConfirmationOrder":return "تایید مالی سفارش ها";
    case "purchaseConfirmationInvoice":return "تایید خرید فاکتور ها";
    case "addSeller":return "ثبت فروشنده";
    case "getSellers":return "لیست فروشنده ها";
    case "getAllSupport":return "مشاهده تمام سفارش ها و فرصت فروش ها در پشتیبانی";
    case "getSupportTickets":return "پشتیبانی";
    case "getReport":return "گزارش ها";
    default:break;
  }
}
